/* eslint-disable import/no-default-export */
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/controller-factory/controllerFactory';
import {Experiments} from '../../constants';
import {ConditionalController} from '@wix/wixstores-client-storefront-common';
import {WishlistController} from '../../wishlist/viewerScript/WishlistController';
import {OldWishlistController} from '../../wishlist/viewerScript/OldWishlistController';

export default ConditionalController(
  Experiments.RemoveControllerFactory,
  WishlistController,
  controllerFactory(OldWishlistController, {shouldSkipMultilingual: true})
);
